import { render, staticRenderFns } from "./TrainingCreateModal.vue?vue&type=template&id=36efe774&scoped=true&"
import script from "./TrainingCreateModal.vue?vue&type=script&lang=js&"
export * from "./TrainingCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCreateModal.vue?vue&type=style&index=0&id=36efe774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efe774",
  null
  
)

export default component.exports